/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Article16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.058}
    >
      <path d="M2.867 15A1.866 1.866 0 0 1 1 13.133V8.467h3.733v4.666A1.866 1.866 0 0 1 2.867 15" />
      <path d="M4.733 8.467V1H15v12.133A1.866 1.866 0 0 1 13.133 15H2.867M7.533 3.8H12.2M7.533 6.6H12.2M7.533 9.4H12.2m-4.667 2.8H9.4" />
    </g>
  </svg>
);

export const __descriptor_Article = {
  name: "Article",
  instances: [{ size: 16, Component: Article16 }],
} as const;
